module.exports = __webpack_public_path__ + "media/moving.5cf21e81.mp3";